import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { DateInput } from '@blueprintjs/datetime';
import moment from 'moment';

const ElementWrapper = styled.div`
  display: flex;
`;

const MAX_DATE = 20;

export default class DateInputElement extends React.PureComponent {
  static propTypes = {
    onChange: PropTypes.func,
  };

  render() {
    const { label, ...otherProps } = this.props;
    return (
      <ElementWrapper>
        <DateInput
          maxDate={moment().add(MAX_DATE, 'year').toDate()}
          {...otherProps}
        />
      </ElementWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/elements/date-input/index.js